var Config = {
    active: false,
    loggedIn: function () { return false; },
    prod: true,
};
var Globals = {
    window: function () { return window; },
    document: function () { return document; },
    config: function () { return Config; },
    timestamp: function () { return Date.now(); },
    dataLayer: function () { return window.dataLayer || (window.dataLayer = []); },
};

// this is the Google Tag Manager initialization script
var init = function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': Globals.timestamp(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0];
    var j = d.createElement(s);
    var dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    var parent = f.parentNode;
    parent.insertBefore(j, f);
};
var GTM = { init: init };

var getEuros = function (euroCents) { return (euroCents ? (euroCents / 100).toFixed(2) : '0.00'); };
var Utils = { getEuros: getEuros };

var SEPARATOR = '|';
// TODO: In case of the new embedded frontends that are running in the frame of the old shops GTM is very likely to be
// initiated. The state of this config's active status is questionable. A more general approach should be implemented
// with the refactoring of the tracking packages.
// When the gtm client is configured it will be initialized and activated
// If no GTM-ID is given, it is assumed, that the GTM script are already initialized, and the data layer can be used.
// This case is needed for Mobile-Shop and PC-Shop where the GTM script is loaded in the index.html
// For more information see README.md
var configure = function (_a) {
    var gtmId = _a.gtmId, loginAccessor = _a.loginAccessor, prod = _a.prod;
    var config = Globals.config();
    config.active = true;
    loginAccessor && (config.loggedIn = loginAccessor);
    prod !== undefined && (config.prod = prod);
    gtmId && GTM.init(Globals.window(), Globals.document(), 'script', 'dataLayer', gtmId);
};
var push = function (data, checkForExternalActivation) {
    if (!Globals.config().active && !checkForExternalActivation) {
        Globals.config().prod || Globals.window().console.log('GTM tracking inactive!');
        return;
    }
    else if (checkForExternalActivation && !Globals.dataLayer()) {
        process.env.NODE_ENV === 'production' || Globals.window().console.log('GTM tracking inactive!');
        return;
    }
    Globals.dataLayer().push(data);
};
var pushEcommerce = function (data) {
    if (!Globals.config().active) {
        Globals.config().prod || Globals.window().console.log('GTM tracking inactive!');
        return;
    }
    Globals.dataLayer().push({ ecommerce: null }); // Clear the previous ecommerce object.
    Globals.dataLayer().push(data);
};
var reset = function () {
    // to keep the references to the array
    Globals.dataLayer().length = 0;
};
// for some reason the newCustomer field is expected to contain strings instead of a boolean
var getNewCustomerString = function (newCustomer) { return (newCustomer ? 'Neukunde' : 'Bestandskunde'); };
// === Standard tracking ===
var basketDisplayed = function (_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, total = _a.total;
    push({
        event: 'basketDisplayed',
        basketQty: items.reduce(function (total, item) { return total + (item.amount || 0); }, 0),
        basketTotal: Utils.getEuros(total),
        articleIds: items.map(function (item) { return item.articleId; }).join(SEPARATOR),
        articlePrices: items.map(function (item) { return Utils.getEuros(item.price); }).join(SEPARATOR),
        articleAmounts: items.map(function (item) { return item.amount || 0; }).join(SEPARATOR),
    });
};
var basketBuy = function (_a, newCustomerFlag) {
    var _b = _a.hashedOrderToken, hashedOrderToken = _b === void 0 ? '' : _b, _c = _a.hashedCustomerId, hashedCustomerId = _c === void 0 ? '' : _c, total = _a.total, shippingCosts = _a.shippingCosts, totalGoods = _a.totalGoods, _d = _a.totalBonus, totalBonus = _d === void 0 ? 0 : _d, couponAmount = _a.couponAmount, _e = _a.items, items = _e === void 0 ? [] : _e, adCode = _a.adCode, adPartnerType = _a.adPartnerType, totalMargin = _a.totalMargin;
    push({
        event: 'basketBuy',
        transactionId: hashedOrderToken,
        transactionAffiliation: '',
        transactionTotal: Utils.getEuros(total),
        // TODO UH: transactionTax: '',
        transactionShipping: Utils.getEuros(shippingCosts),
        transactionProducts: items.map(function (item) { return ({
            sku: item.articleId,
            name: item.title,
            category: item.productType,
            price: Utils.getEuros(item.price),
            quantity: item.amount || 0,
        }); }),
        articleIds: items.map(function (item) { return item.articleId; }).join(SEPARATOR),
        binderNames: items.map(function (item) { return item.binderName; }).join(SEPARATOR),
        titles: items.map(function (item) { return item.title; }).join(SEPARATOR),
        prices: items.map(function (item) { return Utils.getEuros(item.price); }).join(SEPARATOR),
        hashedOrderToken: hashedOrderToken,
        hashedCustomerId: hashedCustomerId,
        shippingCosts: Utils.getEuros(shippingCosts),
        articleTotal: Utils.getEuros(totalGoods),
        couponValue: Utils.getEuros(couponAmount),
        totalBonus: totalBonus,
        adCode: adCode,
        adPartnerType: adPartnerType,
        // TODO UH: 'adCodeExtraParamName': '${libri:toJavaScript(DISP_ORDER.advertisementExtraParameterName)}',
        // TODO UH: 'adCodeExtraParamValue': '${libri:toJavaScript(DISP_ORDER.advertisementExtraParameterValue)}',
        adCodeOrderToken: hashedOrderToken,
        newCustomer: getNewCustomerString(newCustomerFlag),
        totalMargin: totalMargin,
    });
};
var pageView = function (url, pagePath, pageTitle) {
    push({
        event: 'pageView',
        url: url,
        pagePath: pagePath,
        pageTitle: pageTitle,
    });
};
var magazineView = function (url, breadcrumb) {
    push({
        event: 'magazineView',
        url: url,
        breadcrumb: breadcrumb,
    });
};
var search = function (_a) {
    var searchTerm = _a.searchTerm, searchTermCorrection = _a.searchTermCorrection, resultCount = _a.resultCount;
    push({
        event: 'search',
        searchTerm: searchTerm,
        searchTermCorrection: searchTermCorrection,
        resultCount: resultCount,
    }, true);
};
var suggest = function (_a) {
    var suggestSearchTerm = _a.suggestSearchTerm, resultCountAuthors = _a.resultCountAuthors, resultCountCategory = _a.resultCountCategory, resultCountTitle = _a.resultCountTitle, resultCountTop = _a.resultCountTop;
    push({
        event: 'suggest',
        suggestSearchTerm: suggestSearchTerm,
        resultCountAuthors: resultCountAuthors,
        resultCountCategory: resultCountCategory,
        resultCountTitle: resultCountTitle,
        resultCountTop: resultCountTop,
    }, true);
};
var resetDataLayer = function () {
    reset();
};
var articleView = function (_a) {
    var articleId = _a.articleId, amount = _a.amount, price = _a.price, title = _a.title, authors = _a.authors, binderName = _a.binderName, productType = _a.productType, availabilityMessage = _a.availabilityMessage;
    push({
        event: 'productView',
        articleId: articleId,
        amount: amount,
        name: title,
        price: price,
        authors: authors,
        binderName: binderName,
        productCategory: productType,
        availabilityText: availabilityMessage,
    });
    // GA4
    pushEcommerce({
        event: 'view_item',
        ecommerce: {
            items: [
                {
                    item_name: title,
                    item_id: articleId,
                    price: price,
                    item_category: productType,
                    quantity: 1,
                },
            ],
        },
    });
};
var loggedInCustomer = function (_a) {
    var email = _a.email, myshopFlag = _a.myshopFlag, newCustomer = _a.newCustomer;
    push({
        event: 'customer',
        eMail: email,
        myshopFlag: myshopFlag,
        newCustomer: getNewCustomerString(newCustomer),
        loggedIn: true,
    });
};
var loggedOutCustomer = function () {
    push({
        event: 'customer',
        loggedIn: false,
    });
};
// === Enhanced E-Commerce tracking ====
var CheckoutSteps = Object.freeze({
    CART: 1,
    LOGIN: 2,
    ACCOUNT_CREATION: 3,
    LAST_CHECK: 4,
});
var getECommerceProducts = function (items) {
    if (items === void 0) { items = []; }
    return items.map(function (item) { return ({
        id: item.articleId,
        name: item.title,
        price: Number(Utils.getEuros(item.price)),
        category: item.productType,
        quantity: (item.amount && Math.abs(item.amount)) || 0, // Google only uses positive numbers even for remove-from-basket
    }); });
};
var getGA4Products = function (items) {
    if (items === void 0) { items = []; }
    return items.map(function (item) { return ({
        item_id: item.articleId,
        item_name: item.title,
        price: Number(Utils.getEuros(item.price)),
        item_category: item.productType,
        item_brand: item.binderName,
        quantity: (item.amount && Math.abs(item.amount)) || 0, // Google only uses positive numbers even for remove-from-basket
    }); });
};
var eCommerceCheckout = function (step, cart) {
    var checkoutData = cart
        ? {
            actionField: { step: CheckoutSteps[step] },
            products: getECommerceProducts(cart.items),
        }
        : { actionField: { step: CheckoutSteps[step] } };
    pushEcommerce({
        event: 'EEcheckout',
        ecommerce: {
            checkout: checkoutData,
        },
    });
    // GA4
    pushEcommerce({
        event: 'begin_checkout',
        ecommerce: {
            items: cart ? getGA4Products(cart.items) : [],
        },
    });
};
var eCommercePurchase = function (_a) {
    var _b = _a.hashedOrderToken, hashedOrderToken = _b === void 0 ? '' : _b, total = _a.total, shippingCosts = _a.shippingCosts, items = _a.items, affiliation = _a.affiliation, coupon = _a.coupon;
    pushEcommerce({
        event: 'EEtransaction',
        ecommerce: {
            purchase: {
                actionField: {
                    id: hashedOrderToken,
                    affiliation: affiliation,
                    revenue: Number(Utils.getEuros(total)),
                    // TODO UH: tax: '4.90',
                    shipping: Number(Utils.getEuros(shippingCosts)),
                    coupon: coupon,
                },
                products: getECommerceProducts(items),
            },
        },
    });
    // GA4
    pushEcommerce({
        event: 'purchase',
        ecommerce: {
            transaction_id: hashedOrderToken,
            affiliation: affiliation,
            value: Number(Utils.getEuros(total)),
            shipping: Number(Utils.getEuros(shippingCosts)),
            currency: 'EUR',
            coupon: coupon,
            items: getGA4Products(items),
        },
    });
};
var eCommerceAddToBasket = function (items) {
    pushEcommerce({
        event: 'EEaddToBasket',
        ecommerce: {
            add: {
                products: getECommerceProducts(items),
            },
        },
    });
    // GA4
    pushEcommerce({
        event: 'add_to_cart',
        ecommerce: {
            items: getGA4Products(items),
        },
    });
};
var eCommerceRemoveFromBasket = function (items) {
    pushEcommerce({
        event: 'EEremoveFromBasket',
        ecommerce: {
            remove: {
                products: getECommerceProducts(items),
            },
        },
    });
    // GA4
    pushEcommerce({
        event: 'remove_from_cart',
        ecommerce: {
            items: getGA4Products(items),
        },
    });
};
var eCommerceRefund = function (_a) {
    var _b = _a.hashedOrderToken, hashedOrderToken = _b === void 0 ? '' : _b, _c = _a.items, items = _c === void 0 ? [] : _c;
    // GA4
    pushEcommerce({
        event: 'refund',
        ecommerce: {
            transaction_id: hashedOrderToken,
            items: getGA4Products(items),
        },
    });
};
var Track = {
    configure: configure,
    basketDisplayed: basketDisplayed,
    basketBuy: basketBuy,
    search: search,
    suggest: suggest,
    pageView: pageView,
    resetDataLayer: resetDataLayer,
    magazineView: magazineView,
    articleView: articleView,
    getNewCustomerString: getNewCustomerString,
    loggedInCustomer: loggedInCustomer,
    loggedOutCustomer: loggedOutCustomer,
    eCommerceCheckout: eCommerceCheckout,
    eCommercePurchase: eCommercePurchase,
    eCommerceAddToBasket: eCommerceAddToBasket,
    eCommerceRemoveFromBasket: eCommerceRemoveFromBasket,
    eCommerceRefund: eCommerceRefund,
};

export { Track };
